/**
 * Converts a grid sort value like "lastLogin_desc" into the
 * snake_case form expected by the API, e.g. "last_login_desc".
 *
 * Pass `overrides` when the API field name differs from the generic
 * camelCase→snake_case conversion, e.g. { createdAt: 'date_created' }.
 */
export function getSortFieldForApi(
  fieldName: string,
  overrides?: Record<string, string>,
): string {
  const baseFieldName = fieldName.replace(/_(asc|desc)$/, '');
  const mappedFieldName =
    overrides?.[baseFieldName] ?? baseFieldName.replace(/([A-Z])/g, '_$1').toLowerCase();
  const sortDirection = fieldName.endsWith('_desc') ? 'desc' : 'asc';
  return `${mappedFieldName}_${sortDirection}`;
}
